import LTR from "@brand-icons/ploom/ui-checkplus-circle/ui-checkplus-circle-ltr.svg";
import RTL from "@brand-icons/ploom/ui-checkplus-circle/ui-checkplus-circle-rtl.svg";

import { iconFactory } from "../iconFactory";

export const UiCheckplusCircleIcon = iconFactory("UiCheckplusCircleIcon", LTR, RTL);
